import { apiRequest } from "@/api/apiRequest";

export const fetchPartners = async () =>
  apiRequest({
    method: "GET",
    path: "partners"
  });
